// Product catalog data extracted from magicprint.sowebshop.com
// Categories: Heren (1096), Dames (887), Kids & Baby (246), Sport (381),
// Workwear (1214), Accessoires (547), Tassen (437), Organic (183)

export interface Product {
 id: string;
 name: string;
 brand: string;
 code: string;
 category: string;
 subcategory: string;
 image?: string;
}

export interface ProductCategory {
 id: string;
 slug: string;
 name: string;
 description: string;
 icon: string;
 productCount: number;
 image: string;
 subcategories: { name: string; slug: string }[];
 products: Product[];
}

export const productCategories: ProductCategory[] = [
 {
 id: "heren",
 slug: "heren",
 name: "Heren",
 description: "T-shirts, polo's, hoodies, sweaters, jassen en broeken voor heren. Meer dan 1000 producten van topmerken.",
 icon: "",
 productCount: 1096,
 image: "https://cdn.europeancatalog.com/pictures/BY004_2026.jpg?w=600",
 subcategories: [
 { name: "T-shirts", slug: "t-shirts" },
 { name: "Polo's", slug: "polos" },
 { name: "Hoodies", slug: "hoodies" },
 { name: "Sweaters", slug: "sweaters" },
 { name: "Jassen", slug: "jassen" },
 { name: "Broeken", slug: "broeken" },
 { name: "Hemden", slug: "hemden" },
 { name: "Bodywarmers", slug: "bodywarmers" },
 ],
 products: [
 { id: "by004", name: "T-shirt met ronde hals", brand: "Build Your Brand", code: "BY004", category: "heren", subcategory: "t-shirts" },
 { id: "by189", name: "T-shirt met verwassen look", brand: "Build Your Brand", code: "BY189", category: "heren", subcategory: "t-shirts" },
 { id: "by102", name: "Oversized T-shirt zware stof", brand: "Build Your Brand", code: "BY102", category: "heren", subcategory: "t-shirts" },
 { id: "cgtm042", name: "T-shirt #E190", brand: "B&C", code: "CGTM042", category: "heren", subcategory: "t-shirts" },
 { id: "cgtm048", name: "T-shirt Inspire Plus", brand: "B&C", code: "CGTM048", category: "heren", subcategory: "t-shirts" },
 { id: "k200", name: "Polo met korte mouwen", brand: "Kariban", code: "K200", category: "heren", subcategory: "polos" },
 { id: "cgpm430", name: "Polo My Polo 180", brand: "B&C", code: "CGPM430", category: "heren", subcategory: "polos" },
 { id: "k477", name: "Polo Jersey", brand: "Kariban", code: "K477", category: "heren", subcategory: "polos" },
 { id: "by284", name: "Hoodie met zachte touch", brand: "Build Your Brand", code: "BY284", category: "heren", subcategory: "hoodies" },
 { id: "by268", name: "Oversized hoodie", brand: "Build Your Brand", code: "BY268", category: "heren", subcategory: "hoodies" },
 { id: "by162", name: "Zware hoodie", brand: "Build Your Brand", code: "BY162", category: "heren", subcategory: "hoodies" },
 { id: "by011", name: "Zware hoodie", brand: "Build Your Brand", code: "BY011", category: "heren", subcategory: "hoodies" },
 { id: "by012", name: "Zware hoodie met rits", brand: "Build Your Brand", code: "BY012", category: "heren", subcategory: "hoodies" },
 { id: "cgwm647", name: "Sweater ID.202", brand: "B&C", code: "CGWM647", category: "heren", subcategory: "sweaters" },
 { id: "k474", name: "Sweater ronde hals", brand: "Kariban", code: "K474", category: "heren", subcategory: "sweaters" },
 { id: "bbmayde", name: "Maydery jas", brand: "Bombers Original", code: "BBMAYDE", category: "heren", subcategory: "jassen" },
 { id: "bbdavis", name: "Davis jas", brand: "Bombers Original", code: "BBDAVIS", category: "heren", subcategory: "jassen" },
 { id: "bt8845", name: "Monaco broek", brand: "Brook Taverner", code: "BT8845", category: "heren", subcategory: "broeken" },
 ],
 },
 {
 id: "dames",
 slug: "dames",
 name: "Dames",
 description: "T-shirts, polo's, hoodies, sweaters, jassen en jurken voor dames. Ruim 880 producten beschikbaar.",
 icon: "",
 productCount: 887,
 image: "https://cdn.europeancatalog.com/pictures/BY268_2026.jpg?w=600",
 subcategories: [
 { name: "T-shirts", slug: "t-shirts" },
 { name: "Polo's", slug: "polos" },
 { name: "Hoodies", slug: "hoodies" },
 { name: "Sweaters", slug: "sweaters" },
 { name: "Jassen", slug: "jassen" },
 { name: "Tops & Tanktops", slug: "tops" },
 { name: "Jurken & Rokken", slug: "jurken" },
 ],
 products: [
 { id: "d-by284", name: "Hoodie met zachte touch", brand: "Build Your Brand", code: "BY284", category: "dames", subcategory: "hoodies" },
 { id: "d-by268", name: "Oversized hoodie", brand: "Build Your Brand", code: "BY268", category: "dames", subcategory: "hoodies" },
 { id: "d-by163", name: "Zware sweater", brand: "Build Your Brand", code: "BY163", category: "dames", subcategory: "sweaters" },
 { id: "d-cgtw043", name: "T-shirt #E190 dames", brand: "B&C", code: "CGTW043", category: "dames", subcategory: "t-shirts" },
 { id: "d-cgtw049", name: "T-shirt Inspire Plus dames", brand: "B&C", code: "CGTW049", category: "dames", subcategory: "t-shirts" },
 { id: "d-k242", name: "Polo dames korte mouwen", brand: "Kariban", code: "K242", category: "dames", subcategory: "polos" },
 { id: "d-cgpw461", name: "Polo My Polo 180 dames", brand: "B&C", code: "CGPW461", category: "dames", subcategory: "polos" },
 { id: "d-k400", name: "Tanktop dames", brand: "Kariban", code: "K400", category: "dames", subcategory: "tops" },
 { id: "d-k491", name: "Jasje blazer dames", brand: "Kariban", code: "K491", category: "dames", subcategory: "jassen" },
 { id: "d-k493", name: "Softshell jas dames", brand: "Kariban", code: "K493", category: "dames", subcategory: "jassen" },
 { id: "d-cgww647", name: "Sweater ID.202 dames", brand: "B&C", code: "CGWW647", category: "dames", subcategory: "sweaters" },
 { id: "d-k481", name: "Hoodie dames", brand: "Kariban", code: "K481", category: "dames", subcategory: "hoodies" },
 ],
 },
 {
 id: "kids",
 slug: "kids-baby",
 name: "Kids & Baby",
 description: "T-shirts, hoodies, sweaters en fleeces voor kinderen en baby's. 246 producten in kindermaten.",
 icon: "",
 productCount: 246,
 image: "https://cdn.europeancatalog.com/pictures/CGWK002_2026.jpg?w=600",
 subcategories: [
 { name: "T-shirts", slug: "t-shirts" },
 { name: "Hoodies", slug: "hoodies" },
 { name: "Sweaters", slug: "sweaters" },
 { name: "Polo's", slug: "polos" },
 { name: "Fleeces", slug: "fleeces" },
 { name: "Baby", slug: "baby" },
 ],
 products: [
 { id: "k-lw031", name: "Kinderfleece met 1/4 rits", brand: "Larkwood", code: "LW031", category: "kids", subcategory: "fleeces" },
 { id: "k-cgwk002", name: "Hoodie ID.333 kids", brand: "B&C", code: "CGWK002", category: "kids", subcategory: "hoodies" },
 { id: "k-cgwk001", name: "Sweater ID.332 kids ronde hals", brand: "B&C", code: "CGWK001", category: "kids", subcategory: "sweaters" },
 { id: "k-cgtk301", name: "T-shirt #E150 kids", brand: "B&C", code: "CGTK301", category: "kids", subcategory: "t-shirts" },
 { id: "k-k239", name: "Polo kids korte mouwen", brand: "Kariban", code: "K239", category: "kids", subcategory: "polos" },
 { id: "k-lw030", name: "Baby hoodie", brand: "Larkwood", code: "LW030", category: "kids", subcategory: "baby" },
 { id: "k-lw050", name: "Baby T-shirt", brand: "Larkwood", code: "LW050", category: "kids", subcategory: "baby" },
 { id: "k-k478", name: "Sweater kids met ronde hals", brand: "Kariban", code: "K478", category: "kids", subcategory: "sweaters" },
 ],
 },
 {
 id: "sport",
 slug: "sport",
 name: "Sport",
 description: "Sportshirts, trainingsbroeken, shorts en sportaccessoires. 381 producten voor teams en verenigingen.",
 icon: "",
 productCount: 381,
 image: "https://cdn.europeancatalog.com/pictures/PA438_2026.jpg?w=600",
 subcategories: [
 { name: "T-shirts & Tops", slug: "t-shirts" },
 { name: "Polo's", slug: "polos" },
 { name: "Broeken & Shorts", slug: "broeken" },
 { name: "Jassen & Vesten", slug: "jassen" },
 { name: "Caps & Mutsen", slug: "caps" },
 { name: "Sportaccessoires", slug: "accessoires" },
 ],
 products: [
 { id: "s-kp357", name: "Canvaskatoenen pet 5 panelen Gold Label", brand: "K-up", code: "KP357", category: "sport", subcategory: "caps" },
 { id: "s-kp353", name: "Sandwich pet 5 panelen Gold Label", brand: "K-up", code: "KP353", category: "sport", subcategory: "caps" },
 { id: "s-pa438", name: "Sport T-shirt", brand: "Proact", code: "PA438", category: "sport", subcategory: "t-shirts" },
 { id: "s-pa445", name: "Sport polo korte mouwen", brand: "Proact", code: "PA445", category: "sport", subcategory: "polos" },
 { id: "s-pa186", name: "Trainingbroek", brand: "Proact", code: "PA186", category: "sport", subcategory: "broeken" },
 { id: "s-pa101", name: "Sport short", brand: "Proact", code: "PA101", category: "sport", subcategory: "broeken" },
 { id: "s-pa323", name: "Sportjas met rits", brand: "Proact", code: "PA323", category: "sport", subcategory: "jassen" },
 { id: "s-pa578", name: "Sporthanddoek", brand: "Proact", code: "PA578", category: "sport", subcategory: "accessoires" },
 ],
 },
 {
 id: "workwear",
 slug: "workwear",
 name: "Workwear",
 description: "Werkkleding, veiligheidskleding, schorten, labsjassen en bedrijfskleding. Meer dan 1200 producten.",
 icon: "",
 productCount: 1214,
 image: "https://cdn.europeancatalog.com/pictures/PR603_2026.jpg?w=600",
 subcategories: [
 { name: "Werkjassen", slug: "werkjassen" },
 { name: "Werkbroeken", slug: "werkbroeken" },
 { name: "Veiligheidskleding", slug: "veiligheidskleding" },
 { name: "Schorten", slug: "schorten" },
 { name: "Labjassen", slug: "labjassen" },
 { name: "Polo's & Shirts", slug: "polos" },
 { name: "Bodywarmers", slug: "bodywarmers" },
 { name: "Softshells", slug: "softshells" },
 ],
 products: [
 { id: "w-pr603", name: "Labjas", brand: "Premier", code: "PR603", category: "workwear", subcategory: "labjassen" },
 { id: "w-pr024", name: "Tabard", brand: "Premier", code: "PR024", category: "workwear", subcategory: "schorten" },
 { id: "w-pr023", name: "Ripstop schort", brand: "Premier", code: "PR023", category: "workwear", subcategory: "schorten" },
 { id: "w-wk440", name: "Werkjas", brand: "WK. Designed to Work", code: "WK440", category: "workwear", subcategory: "werkjassen" },
 { id: "w-wk738", name: "Werkbroek", brand: "WK. Designed to Work", code: "WK738", category: "workwear", subcategory: "werkbroeken" },
 { id: "w-wk304", name: "Unisex polo werkkleding", brand: "WK. Designed to Work", code: "WK304", category: "workwear", subcategory: "polos" },
 { id: "w-wk607", name: "Bodywarmer", brand: "WK. Designed to Work", code: "WK607", category: "workwear", subcategory: "bodywarmers" },
 { id: "w-k401", name: "Softshell jas", brand: "Kariban", code: "K401", category: "workwear", subcategory: "softshells" },
 { id: "w-k9102", name: "Veiligheidshesje", brand: "Kariban", code: "K9102", category: "workwear", subcategory: "veiligheidskleding" },
 ],
 },
 {
 id: "accessoires",
 slug: "accessoires",
 name: "Accessoires",
 description: "Caps, mutsen, sjaals, handdoeken en andere accessoires. 547 producten om te bedrukken of borduren.",
 icon: "",
 productCount: 547,
 image: "https://cdn.europeancatalog.com/pictures/RC092X_2026.jpg?w=600",
 subcategories: [
 { name: "Caps & Petten", slug: "caps" },
 { name: "Mutsen & Beanies", slug: "mutsen" },
 { name: "Sjaals & Bandana's", slug: "sjaals" },
 { name: "Handdoeken", slug: "handdoeken" },
 { name: "Stropdassen", slug: "stropdassen" },
 { name: "Hoeden", slug: "hoeden" },
 ],
 products: [
 { id: "a-rc092x", name: "Vintage pet van puur katoen", brand: "Result", code: "RC092X", category: "accessoires", subcategory: "caps" },
 { id: "a-rc986x", name: "Gerecyclede bucket hat", brand: "Result", code: "RC986X", category: "accessoires", subcategory: "hoeden" },
 { id: "a-tc014", name: "Fluwelen golfhanddoek", brand: "Towel City", code: "TC014", category: "accessoires", subcategory: "handdoeken" },
 { id: "a-kp011", name: "Klassieke pet 6 panelen", brand: "K-up", code: "KP011", category: "accessoires", subcategory: "caps" },
 { id: "a-kp041", name: "Gebreide beanie", brand: "K-up", code: "KP041", category: "accessoires", subcategory: "mutsen" },
 { id: "a-kp064", name: "Sjaal", brand: "K-up", code: "KP064", category: "accessoires", subcategory: "sjaals" },
 { id: "a-pr700", name: "Horizontaal gestreepte stropdas", brand: "Premier", code: "PR700", category: "accessoires", subcategory: "stropdassen" },
 { id: "a-kp620", name: "Bandana", brand: "K-up", code: "KP620", category: "accessoires", subcategory: "sjaals" },
 ],
 },
 {
 id: "tassen",
 slug: "tassen",
 name: "Tassen",
 description: "Draagtassen, rugzakken, sportassen en shoppers. 437 tassen om te bedrukken met uw logo.",
 icon: "",
 productCount: 437,
 image: "https://cdn.europeancatalog.com/pictures/W335_2026.jpg?w=600",
 subcategories: [
 { name: "Draagtassen & Shoppers", slug: "draagtassen" },
 { name: "Rugzakken", slug: "rugzakken" },
 { name: "Sportassen", slug: "sportassen" },
 { name: "Laptoptassen", slug: "laptoptassen" },
 { name: "Reistassen", slug: "reistassen" },
 { name: "Katoenen tassen", slug: "katoenen-tassen" },
 ],
 products: [
 { id: "t-w336", name: "Oversized canvas cabas tas met luipaardprint", brand: "Westford Mill", code: "W336", category: "tassen", subcategory: "draagtassen" },
 { id: "t-w335", name: "Canvas cabas tas met luipaardprint", brand: "Westford Mill", code: "W335", category: "tassen", subcategory: "draagtassen" },
 { id: "t-w101", name: "Katoenen draagtas", brand: "Westford Mill", code: "W101", category: "tassen", subcategory: "katoenen-tassen" },
 { id: "t-w107", name: "Stevige katoenen shopper", brand: "Westford Mill", code: "W107", category: "tassen", subcategory: "draagtassen" },
 { id: "t-ki0145", name: "Rugzak", brand: "Kimood", code: "KI0145", category: "tassen", subcategory: "rugzakken" },
 { id: "t-ki0637", name: "Sporttas", brand: "Kimood", code: "KI0637", category: "tassen", subcategory: "sportassen" },
 { id: "t-ki0918", name: "Laptoptas", brand: "Kimood", code: "KI0918", category: "tassen", subcategory: "laptoptassen" },
 { id: "t-ki0840", name: "Reistas", brand: "Kimood", code: "KI0840", category: "tassen", subcategory: "reistassen" },
 ],
 },
 {
 id: "organic",
 slug: "organic",
 name: "Organic / Eco",
 description: "Duurzame en biologische kleding. 183 eco-vriendelijke producten van biologisch katoen en gerecyclede materialen.",
 icon: "",
 productCount: 183,
 image: "https://cdn.europeancatalog.com/pictures/KP356_2026.jpg?w=600",
 subcategories: [
 { name: "T-shirts", slug: "t-shirts" },
 { name: "Hoodies", slug: "hoodies" },
 { name: "Sweaters", slug: "sweaters" },
 { name: "Polo's", slug: "polos" },
 { name: "Caps & Accessoires", slug: "caps" },
 ],
 products: [
 { id: "o-kp356", name: "Biologisch katoenen pet 6 panelen Gold Label", brand: "K-up", code: "KP356", category: "organic", subcategory: "caps" },
 { id: "o-kp355", name: "Biologisch katoenen pet 5 panelen Gold Label", brand: "K-up", code: "KP355", category: "organic", subcategory: "caps" },
 { id: "o-cgtm046", name: "T-shirt Organic Inspire", brand: "B&C", code: "CGTM046", category: "organic", subcategory: "t-shirts" },
 { id: "o-cgtm044", name: "T-shirt Organic Inspire Plus", brand: "B&C", code: "CGTM044", category: "organic", subcategory: "t-shirts" },
 { id: "o-cgpm432", name: "Polo My Eco Polo 65/35", brand: "B&C", code: "CGPM432", category: "organic", subcategory: "polos" },
 { id: "o-k495", name: "Organic sweater", brand: "Kariban", code: "K495", category: "organic", subcategory: "sweaters" },
 { id: "o-k4009", name: "Organic hoodie", brand: "Kariban", code: "K4009", category: "organic", subcategory: "hoodies" },
 { id: "o-k4027", name: "Organic T-shirt", brand: "Kariban", code: "K4027", category: "organic", subcategory: "t-shirts" },
 ],
 },
];

export const getAllProducts = (): Product[] =>
 productCategories.flatMap((c) => c.products);

export const getCategoryBySlug = (slug: string): ProductCategory | undefined =>
 productCategories.find((c) => c.slug === slug);

export const getProductsByCategory = (categorySlug: string): Product[] =>
 getCategoryBySlug(categorySlug)?.products ?? [];

export const totalProductCount = productCategories.reduce((sum, c) => sum + c.productCount, 0);
